import styled from 'styled-components';
import * as MdIcons from 'react-icons/md';
import { useModalProvider } from "../../../Providers/ModalProvider";
import ModalHeader from "../../../Components/ModalHeader/ModalHeader";
import AccountSettingsModal from '../../../Components/PageHeader/AccountSettingsModal';
import { useState, useEffect } from 'react';
import { useEndpointProvider } from '../../../Providers/EndpointProvider';
import { useAuthProvider } from "../../../Providers/AuthProvider";
import { useBackendLinksProvider } from '../../../Providers/BackendLinksProvider';
import ModalScrollbar from '../../../Components/ModalScrollbar/ModalScrollbar';
import { MobergButton, MobergButtonVariant, MobergButtonShape, MobergTheme, MobergFontSize } from '../../../Moberg';
import { MobergFontFamily } from '../../../Components/MobergFont/MobergFont';
const ChangeEmail = (props) => {
    const authProvider = useAuthProvider()
    const endpointProvider = useEndpointProvider()
    const { openNext } = useModalProvider()
    const { LINKS } = useBackendLinksProvider()
    const [email, setEmail] = useState()
    const [confirmEmail, setConfirmEmail] = useState()
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [disableChangeEmail, setDisableChangeEmail] = useState(true)

    function changeEmail(email) {
        let body = {
            new_email: email,
            password: password
        }

        return endpointProvider.post(LINKS.ACCOUNT.CHANGE_EMAIL, body)
    }

    async function handleChangeEmail(e) {
        if (e) {
            e.preventDefault()
        }
        changeEmail(confirmEmail).then((data) => {
            alert(data)
            setEmail('')
            setConfirmEmail('')
            authProvider.logout()
        }).catch((e) => {
            alert(e);
        })
    }

    useEffect(() => {
        if (!email && !confirmEmail && !password) {
            setDisableChangeEmail(true)
            setShowErrorMessage(false)
        } else if (!email) {
            setDisableChangeEmail(true)
            setErrorMessage("You must enter your email.")
            setShowErrorMessage(true)
        } else if (!confirmEmail) {
            setDisableChangeEmail(true)
            setErrorMessage("You must confirm your email.")
            setShowErrorMessage(true)
        } else if (!password) {
            setDisableChangeEmail(true)
            setErrorMessage("You must enter your password.")
            setShowErrorMessage(true)
        } else if ((email !== confirmEmail)) {
            setDisableChangeEmail(true)
            setErrorMessage("Emails do not match.")
            setShowErrorMessage(true)
        } else if (!email.includes('@')) {
            setDisableChangeEmail(true)
            setErrorMessage("You must enter a valid email.")
            setShowErrorMessage(true)
        } else if ((email === authProvider.currentUser.email) || (confirmEmail === authProvider.currentUser.email)) {
            setDisableChangeEmail(true)
            setErrorMessage('New email must be different than current email.')
            setShowErrorMessage(true)
        }
        else {
            setShowErrorMessage(false)
            setDisableChangeEmail(false)
        }
    }, [password, email, confirmEmail, authProvider.currentUser.email])

    function renderAccountSettingsModal() {
        openNext(<AccountSettingsModal
            escClose={false}
            clickOutsideClose={false}
        />)
    }


    return (
        <ModalContainer>
            <ModalHeader headerText='Account Settings' />
            <ModalScrollbar>
                <ContentContainer>
                    <BackButton onClick={renderAccountSettingsModal}>
                        <MdIcons.MdArrowBack size={20} />
                        <span>Back</span>
                    </BackButton>

                    <PageTitle>Change Email</PageTitle>

                    <InfoCard>
                        <InfoIconWrapper>
                            <MdIcons.MdInfo size={20} style={{ color: '#207dea' }} />
                        </InfoIconWrapper>
                        <InfoText>You will be logged out after changing your email.</InfoText>
                    </InfoCard>

                    <FormCard>
                        <FormGroup>
                            <Label>New Email</Label>
                            <Input 
                                placeholder="example@gmail.com" 
                                onChange={(e) => setEmail(e.target.value)} 
                                type="email" 
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Confirm New Email</Label>
                            <Input 
                                placeholder="example@gmail.com" 
                                onChange={(e) => setConfirmEmail(e.target.value)} 
                                type="email" 
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Password</Label>
                            <Input 
                                placeholder="Password" 
                                onChange={(e) => setPassword(e.target.value)} 
                                type={showPassword ? "text" : ((String(password).length === 0) ? "text" : "password")} 
                                value={password || ""} 
                                onCopy={(e) => e.preventDefault()} 
                                onPaste={(e) => e.preventDefault()} 
                            />
                        </FormGroup>

                        <CheckboxWrapper>
                            <input 
                                id="showPasswordCheckbox" 
                                type="checkbox"
                                onChange={() => { setShowPassword(!showPassword) }}
                            />
                            <CheckboxLabel htmlFor="showPasswordCheckbox">Show Password</CheckboxLabel>
                        </CheckboxWrapper>

                        {showErrorMessage && (
                            <ErrorCard>
                                <MdIcons.MdWarning size={20} style={{ color: '#e64e58', marginRight: '8px' }} />
                                <ErrorText>{errorMessage}</ErrorText>
                            </ErrorCard>
                        )}

                        <ButtonWrapper>
                            <MobergButton
                                theme={MobergTheme.BLUE}
                                variant={MobergButtonVariant.FILLED}
                                onClick={handleChangeEmail}
                                shape={MobergButtonShape.WIDE}
                                fontSize={MobergFontSize.LARGE}
                                disabled={disableChangeEmail}
                            >
                                Change Email
                            </MobergButton>
                        </ButtonWrapper>
                    </FormCard>
                </ContentContainer>
            </ModalScrollbar>
        </ModalContainer>
    )
}

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--color-surface-panel);
    width: 820px;
    max-height: 776px;
`;

const ContentContainer = styled.div`
    max-width: 500px;
    margin: 0 auto;
    padding: 24px 0;
`;

const BackButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    font-family: 'Source Sans Pro';
    font-size: 16px;
    font-weight: 600;
    color: var(--color-text-primary);
    cursor: pointer;
    padding: 8px 12px;
    margin-bottom: 24px;
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover {
        background: var(--color-hover-neutral);
    }
`;

const PageTitle = styled.h1`
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    color: var(--color-text-primary);
    line-height: 150%;
    margin: 0 0 24px 0;
    text-align: center;
`;

const InfoCard = styled.div`
    display: flex;
    align-items: center;
    background: rgba(32, 125, 234, 0.1);
    border: 1px solid rgba(32, 125, 234, 0.3);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
`;

const InfoIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 12px;
`;

const InfoText = styled.p`
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: var(--color-text-primary);
    line-height: 150%;
    margin: 0;
`;

const FormCard = styled.div`
    background: var(--color-surface-menu);
    border-radius: 8px;
    box-shadow: var(--modal-box-shadow);
    padding: 24px;
`;

const FormGroup = styled.div`
    margin-bottom: 24px;
`;

const Label = styled.label`
    display: block;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: var(--color-text-primary);
    line-height: 150%;
    margin-bottom: 8px;
`;

const Input = styled.input`
    width: 100%;
    background: var(--color-input-bg);
    border: 1px solid var(--color-border-default);
    box-sizing: border-box;
    border-radius: 6px;
    height: 48px;
    padding: 12px 16px;
    color: var(--color-text-primary);
    font-family: 'Source Sans Pro';
    font-size: 16px;
    transition: border-color 0.2s ease;

    &:focus {
        outline: none;
        border-color: var(--color-accent-interactive);
    }

    &::placeholder {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        color: var(--text-secondary-color);
    }
`;

const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
        margin: 0;
    }
`;

const CheckboxLabel = styled.label`
    font-family: 'Source Sans Pro';
    font-size: 14px;
    color: var(--color-text-primary);
    margin-left: 8px;
    cursor: pointer;
`;

const ErrorCard = styled.div`
    display: flex;
    align-items: center;
    background: rgba(230, 78, 88, 0.1);
    border: 1px solid rgba(230, 78, 88, 0.3);
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 24px;
`;

const ErrorText = styled.p`
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #e64e58;
    line-height: 150%;
    margin: 0;
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 24px;
`;

export default ChangeEmail;